<template>

    <form v-on:submit.prevent="">
        <BaseInputFloatinglabel v-model="form.name"
                                icon="building"
                                placeholder="Name"
                                type="text"/>

        <BaseInputFloatinglabel v-model="form.street"
                                placeholder="Straße"
                                icon="home"
                                type="text"/>

        <BaseInputFloatinglabel v-model="form.zip"
                                placeholder="PLZ"
                                icon="map-marker-alt"
                                type="text"/>

        <BaseInputFloatinglabel v-model="form.city"
                                placeholder="Stadt"
                                icon="city"
                                type="text"/>

        <BaseInputFloatinglabel v-model="form.country"
                                placeholder="Land"
                                icon="flag"
                                type="text"/>

        <div class="action">
          <BaseButton v-if="type === 'create'"
                       :loading="creating"
                       :disabled="checkForm || creating"
                       icon="plus"
                       label="Erstellen"
                       :submit="true"
                       @click="create"/>
          <BaseButton v-if="hasManagerRole && type === 'edit'"
                       :loading="removing"
                       :disabled="removing"
                       icon="trash"
                       label="Löschen"
                       :remove="true"
                       @click="remove"/>
          <BaseButton v-if="type === 'edit'"
                       :loading="updating"
                       :disabled="checkForm || updating"
                       icon="save"
                       label="Speichern"
                       :submit="true"
                       @click="update"/>
        </div>

    </form>

</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { cloneDeep } from 'lodash'

export default {
  name: 'MediacontactCompanyForm',
  props: ['mediacontactCompany', 'type'],
  data () {
    return {
      form: {},
      creating: false,
      updating: false,
      removing: false
    }
  },
  created () {
    this.form = cloneDeep(this.mediacontactCompany)
  },
  methods: {
    async create () {
      try {
        this.creating = true
        const response = await this.createMediacontactCompany({ data: this.form })
        this.$vfm.hide('mediacontact-company-create')
        this.$toasted.success('Unternehmen ' + response.data.name + ' erstellt', { icon: 'fas fa-building' })
        this.creating = false
        await this.getMediacontactCompanies()
      } catch (error) {
        this.creating = false
      }
    },
    async update () {
      try {
        this.updating = true
        const response = await this.updateMediacontactCompany({ id: this.form.id, data: this.form })
        this.$vfm.hide('mediacontact-company-edit')
        this.$toasted.success('Unternehmen ' + response.data.name + ' aktualisiert', { icon: 'fas fa-building' })
        this.updating = false
        await this.getMediacontactCompany({ id: this.form.id })
      } catch (error) {
        this.creating = false
      }
    },
    async remove () {
      try {
        this.removing = true
        await this.deleteMediacontactCompany({ id: this.form.id })
        this.$vfm.hide('mediacontact-company-edit')
        this.$toasted.success('Unternehmen gelöscht', { icon: 'fas fa-building' })
        this.removing = false
        await this.getMediacontactCompanies()
      } catch (error) {
        this.creating = false
      }
    },
    ...mapActions({
      getMediacontactCompany: 'mediacontactCompanies/fetchSingle',
      getMediacontactCompanies: 'mediacontactCompanies/fetchList',
      createMediacontactCompany: 'mediacontactCompanies/create',
      updateMediacontactCompany: 'mediacontactCompanies/replace',
      deleteMediacontactCompany: 'mediacontactCompanies/destroy'
    })
  },
  computed: {
    checkForm () {
      return !(this.form.name)
    },
    ...mapGetters({
      hasManagerRole: 'auth/hasManagerRole'
    })
  }
}
</script>
